import classnames from 'classnames';
import React from 'react';

class Modal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            toggling: false,
            visible: props.show,
        };
    }

    toggleModal = () => {
        this.setState({
            toggling: !this.state.toggling,
        }, () => {
            setTimeout(() => this.setState({
                toggling: !this.state.toggling,
                visible: !this.state.visible,
            }), 10);
        });
    }

    componentWillReceiveProps(nextProps) {
        // showing
        if (nextProps.show && !this.props.show) {
            return this.toggleModal();
        }
        // hiding
        if (!nextProps.show && this.props.show) {
            return setTimeout(() => this.toggleModal(), 200);
        }
    }

    renderHeader() {
        const { headerExtraContent } = this.props;

        return <div className='modal-header'>
            <h5 className='modal-title'>{this.props.title}</h5>
            {!headerExtraContent && <button type='button' className='close' onClick={this.props.onClose}>
                <span>&times;</span>
            </button>}
            {headerExtraContent}
        </div>;
    }

    renderFooter() {
        const {submitCaption, closeCaption} = this.props;

        return <div className='modal-footer'>
            <div className='container'>
                <div className='row'>
                    {
                        closeCaption && <div className={classnames({
                            'col-lg-12': Boolean(closeCaption && !submitCaption),
                            'col-lg-6': Boolean(closeCaption && submitCaption),
                        })}>
                            {this.renderClose()}
                        </div>
                    }
                    {
                        submitCaption && <div className={classnames({
                            'col-lg-12': Boolean(!closeCaption && submitCaption),
                            'col-lg-6': Boolean(closeCaption && submitCaption),
                        })}>
                            {this.renderSubmit()}
                        </div>
                    }
                </div>
            </div>
        </div>;
    }

    renderClose() {
        return <button
            type='button'
            className='btn btn-secondary btn-block'
            disabled={this.props.closeDisabled}
            onClick={this.props.onClose}
        >
            {this.props.closeCaption}
        </button>;
    }

    renderSubmit() {
        return <button
            type='button'
            className='btn btn-primary btn-block'
            disabled={this.props.submitDisabled}
            onClick={this.props.onSubmit}
        >
            {this.props.submitCaption}
        </button>;
    }

    render() {
        const {show, submitCaption, closeCaption, title, children} = this.props;
        const display = this.state.visible || this.state.toggling ? 'block' : 'none';

        return <div>
            <div
                className={classnames('modal fade', {
                    show: show && !this.state.toggling,
                })}
                style={ {display} }
            >
                <div className='modal-dialog'>
                    <div className='modal-content'>
                        {title && this.renderHeader()}
                        <div className='modal-body'>
                            <div className='container'>
                                <div className='row'>
                                    <div className='col-12'>
                                        {children}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {(closeCaption || submitCaption) && this.renderFooter()}
                    </div>
                </div>
            </div>

            {
                (this.state.visible || this.state.toggling) && <div
                    className={classnames('modal-backdrop fade', {
                        show: show && !this.state.toggling,
                    })}
                />
            }
        </div>;
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js